import Hashids from 'hashids'
const hashids = new Hashids()

const isPrimitiveType = (val, type) => Object.prototype.toString.call(val) === type

export function newIdFromTime() {
  return hashids.encode(new Date().getTime())
}

export function isFunction(val) {
  return isPrimitiveType(val, '[object Function]')
}

export function isNumber(val) {
  return isPrimitiveType(val, '[object Number]')
}

export function isObject(val) {
  return isPrimitiveType(val, '[object Object]')
}

export function isArray(val) {
  return Array.isArray(val)
}

export function isBoolean(val) {
  return isPrimitiveType(val, '[object Boolean]')
}

export function isString(val) {
  return isPrimitiveType(val, '[object String]')
}

// 最大保留max位小数
export function formatNumber(number, max = 2) {
  //TODO: P1 formatNumber要结合locale
  // if (this.context.item.options.number_thousand_separator) {
  //   return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.locale_number_format?.thousands || ',');
  // }
  // if (this.locale_number_format?.decimal!='.') {
  //   v = v.toString().replace('.', this.locale_number_format?.decimal);
  // }
  return parseFloat(number.toFixed(Math.min(max, number.toString().split(".")[1]?.length || 0)));
}

export const hasDynamicValue = (parts) => {
  return parts.some(part => part.Type != 1)
}

export const buildString = (parts, record, entity) => {
  let str = ''
  parts.forEach((part) => {
      var value = ''
      if(part.Type == 1){
          value = part.Data
      }else if(part.Type == 2){
          // Handle field values
          let rawValue = record.fields?.[part.FieldID]
          if(rawValue === undefined || rawValue === null){
            value = ''
          } else {
            // Check if this is an enum field that needs value-to-label conversion
            if(entity && entity.fields) {
              const field = entity.fields.find(f => f.id === part.FieldID)
              if(field && (field.type === 'status' || field.type === 'boolean')) {
                value = convertEnumValue(field, rawValue)
              } else {
                value = rawValue
              }
            } else {
              value = rawValue
            }
          }
      }else if(part.Type == 3){
        let propName = part.Data.toUpperCase()
        if(propName=='ID'){
          value = record.$id
        }else if(propName=='CREATED_AT'){
          value = new Date(record.created_at*1000).toLocaleString()
        }else if(propName=='UPDATED_AT'){
          value = new Date(record.updated_at*1000).toLocaleString()
        }else if(propName=='TAGS'){
          if(!record.tags){
            return
          }
          if(typeof(record.tags)!='object'){
            return
          }
          value = record.tags.join(' ')
        }
      }
      if(value===undefined || value===null){
        value = ''
      }
      str += value
  })
  return str;
}

// Helper function to convert enum field values to display labels
const convertEnumValue = (field, value) => {
  if(field.type === 'boolean') {
    // Boolean fields: 1 = true, 0 = false
    return value === 1 ? 'true' : 'false'
  } else if(field.type === 'status') {
    // Status fields: find the label from options.items based on code
    if(field.options && field.options.options && field.options.options.items) {
      const item = field.options.options.items.find(option => option.code == value)
      return item ? item.value : value
    }
  }
  return value
}

export const transformFileSize = (size) => {
  if (size < 1024 * 1024) {
    return `${formatNumber(size / 1024)}KB`;
  } else if (size >= 1024) {
    return `${formatNumber(size / 1024 / 1024)}M`;
  }
}

export const buildUrl = (parts, record, entity) => {

  let url = buildString(parts, record, entity)

  if(url.trim()==''){
    return ''
  }

  //匹配是否有domain
  if(url.match(/^(http|https):\/\/([\w.]+\/?)\S*/)){
    if(url.startsWith('http://') || url.startsWith('https://')){
        return url
    }else{
        return 'https://' + url
    }
  }else{
    return false;
  }

}

import _uniqBy from "lodash/uniqBy";

export const getRemoteOptions = async (context, input, options) => {

  if(context.item.options.options.mode!='relation'){
    return
  }

  if(typeof(options.onLoading)=='function'){
    options.onLoading(true)
  }

  const { app_id, id: entity_id } = context.entity;
  const params = {
    field_id: context.item.id,
  };

  const res = await context.api.getRelationOptions(app_id, entity_id, {...params, input}).finally(() => {
    if(typeof(options.onLoading)=='function'){
      options.onLoading(false)
    }
  });

  if (res) {
    const { field_id } = context.item.options.options.relation;
    const tempOptions = [];
    res.forEach((item) => {
      if (item.fields?.[field_id] && item.fields?.[field_id] !== "") {
        tempOptions.push({
          value: item.fields?.[field_id],
          label: item.fields?.[field_id],
        });
      }
    });

    const uniqOptions = _uniqBy(tempOptions, "value");

    if(typeof(options.onData)=='function'){
      options.onData(uniqOptions)
    }
  }
}